import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { PersonTypes } from '@frontend/api-person';
import { ModalControlResponse } from '@frontend/design-system';
import { VerificationMetricSidePanel } from '../../components/verification-metric-side-panel';
import { VerifyInsuranceSidePanel } from '../../components/verify-insurance-side-panel';
import { InsuranceProvider } from '../../providers/insurance-provider';
import { InsuranceTypeProvider } from '../../providers/insurance-type-provider';
import { PersonInfoStoreProvider } from '../../providers/person-info-provider';
import { DateRangeOptionValue } from '../../utils/constants';

type UseGetAppointmentDetailsProps = {
  verifyInsuranceModalControl: ModalControlResponse;
  verificationMetricModalControl: ModalControlResponse;
  defaultDateRange: DateRangeOptionValue;
  setDefaultDateRange: (dateRange: DateRangeOptionValue) => void;
  personInfo?: PersonTypes.Person;
  locationId: string;
  shouldShowTuuthFairyReport?: boolean;
  hasVerificationError?: boolean;
  useModal?: boolean;
  /**
   * When opening verify insurance from the eligibility list view, pass the
   * currently displayed appointment date so the matching list query can be
   * invalidated by exact key after verify action.
   */
  eligibilityListAppointmentDate?: string;
  /**
   * When opening verify insurance from the eligibility list view, pass the
   * appointment id of the selected row so it can be forwarded to the manual
   * dental coverage verification request as appointment info.
   */
  eligibilityListAppointmentId?: string;
  /**
   * When opening verify insurance from the eligibility list view, pass the
   * currently selected insurance type (primary/secondary) so the matching list
   * query can be invalidated by exact key after the verify action.
   */
  eligibilityListInsuranceType?: InsuranceType;
};

export const useGetInsuranceVerificationModal = ({
  verifyInsuranceModalControl,
  verificationMetricModalControl,
  defaultDateRange,
  setDefaultDateRange,
  personInfo,
  locationId,
  shouldShowTuuthFairyReport = false,
  hasVerificationError = false,
  useModal = true,
  eligibilityListAppointmentDate,
  eligibilityListAppointmentId,
  eligibilityListInsuranceType,
}: UseGetAppointmentDetailsProps) => {
  const handleReportLearnMoreClick = () => {
    setDefaultDateRange('this-month');
    verificationMetricModalControl.openModal();
  };
  return {
    Modal: (
      <PersonInfoStoreProvider personInfo={personInfo} locationId={locationId}>
        <InsuranceTypeProvider>
          {/**
          verifyInsuranceSidePanel relies only  on the insurance-details API and insurance-verification-details API is disabled since the required
          verification data is already available from insurance-details.
         */}
          <InsuranceProvider personInfo={personInfo} locationId={locationId} disableFetchingVerificationData={true}>
            <VerifyInsuranceSidePanel
              shouldShowTuuthFairyReport={shouldShowTuuthFairyReport}
              hasVerificationError={hasVerificationError}
              useModal={useModal}
              eligibilityListAppointmentDate={eligibilityListAppointmentDate}
              eligibilityListAppointmentId={eligibilityListAppointmentId}
              eligibilityListInsuranceType={eligibilityListInsuranceType}
              {...verifyInsuranceModalControl.modalProps}
              onReportLearnMoreClick={() => handleReportLearnMoreClick()}
            />
          </InsuranceProvider>
          <VerificationMetricSidePanel {...verificationMetricModalControl.modalProps} dateRange={defaultDateRange} />
        </InsuranceTypeProvider>
      </PersonInfoStoreProvider>
    ),
  };
};
